import React from 'react';
import evemts from 'utils/evemts';
import http from 'utils/http';
import { setDeleteAction } from 'store/actions/deleteAction';
import { connect } from 'react-redux';
import Consignee from './Consignee';
import ConsigneeModal from './ConsigneeModal';

class ConsigneeContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // state goes here
      consignees: [],
      consigneeFields: {},
      consigneeFieldsErrors: {},
      filter: {},
      filteredData: [],
      bounce: '',
      requestingUpdate: false,
      submitting: false,
      page: 1,
      limit: 25,
      totalItems: 0,
    };
    this.eventSource = null;
  }

  componentDidMount() {
    this.fetchConsignee();
    this.eventSource = evemts('admin', 'import');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');

      if (msg.data && msg.action && (msg.action == 'add_consignee' || msg.action == 'update_consignee' || msg.action == 'delete_consignee')) {
        this.fetchConsignee(this.state.consigneeFields?.id);
      }
    };
  }
  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close();
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  fetchConsignee = (preserveConsigneeId = null) => {
    const { page, limit, filter } = this.state;
    const queryParams = `page=${page}&limit=${limit}&search=${filter.search || ''}&bounce=${filter.bounce || 'ALL'}`;
    http.get(`consignee?${queryParams}`).then((res) => {
      if (res.data) {
        const payload = res.data?.data;
        const consignees = payload?.consignees || payload || [];
        const totalItems = payload?.totalItems !== undefined ? payload.totalItems : consignees.length;

        this.setState({ 
          consignees,
          filteredData: consignees,
          totalItems,
        }, () => {
          // If preserveConsigneeId is provided, find and select that consignee
          if (preserveConsigneeId) {
            const consignee = consignees.find(c => c.id === preserveConsigneeId);
            if (consignee) {
              this.handleOpen('', 'edit', consignee);
            } else {
              this.handleOpen('', 'edit', consignees[0]);
            }
          } else {
            this.handleOpen('', 'edit', consignees[0]);
          }
        });
      }
    });
  };


  handleOpen = (modal, action, row = { value: [{}] }) => {
    // extra phone_code and phone
    if (row?.phone && row?.phone?.includes('+')) {
      const regex = /^(\+?(\d{1,4}))(\d{10,})$/;
      const phone = row?.phone && row?.phone?.match(regex);
      row.phone_code = phone?.[1] || '+1';
      row.phone = phone?.[3];
    }
    this.setState({
      modal: action == 'add' ? modal : false,
      action,
      consigneeFields: row || {},
      consigneeFieldsErrors: {},
    });
  };

  onClose = () => {
    this.setState({
      modal: false,
      action: false,
      consigneeFields: {},
      consigneeFieldsErrors: {},
    });
  };


  // onRowMailClick = (row) => {
  //   this.setState({
  //     mailFields: row,
  //     mailFieldsErrors: {}
  //   });
  // };

  onChangeConsignee = (e) => {
    let value = e.target.value;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    
    const newConsigneeFields = {
      ...this.state.consigneeFields,
      [e.target.name]: value,
    };
    
    // Re-validate emails if primary email changed
    if (e.target.name === 'email' && newConsigneeFields.mails) {
      const error = { ...this.state.consigneeFieldsErrors };
      if (!error.mails) error.mails = {};
      
      const primaryEmail = value?.toLowerCase();
      const mailErrors = {};
      
      newConsigneeFields.mails.forEach((mail, index) => {
        if (!mail.deleted && mail.email) {
          const emailLower = mail.email.toLowerCase();
          if (emailLower === primaryEmail) {
            mailErrors[index] = 'This email address already exists';
          } else if (error.mails[index]?.includes('already exists')) {
            // Remove duplicate errors if email no longer matches
            delete error.mails[index];
          }
        }
      });
      
      if (Object.keys(mailErrors).length > 0) {
        error.mails = {
          ...error.mails,
          ...mailErrors 
        };
      }
      
      this.setState({
        consigneeFields: newConsigneeFields,
        consigneeFieldsErrors: error,
      });
    } else {
      this.setState({ consigneeFields: newConsigneeFields, });
    }
  };

  validateConsignee = () => {
    const consigneeFields = { ...this.state.consigneeFields };
    const error = {};
    let formValid = true;
    if (!consigneeFields.name || (consigneeFields.name.trim().length === 0)) {
      formValid = false;
      error.name = true;
    }
    // if (!consigneeFields.contactName || (consigneeFields.contactName.trim().length === 0)) {
    //   formValid = false;
    //   error.contactName = true;
    // }
    // if (!consigneeFields.address || (consigneeFields.address.trim().length === 0)) {
    //   formValid = false;
    //   error.address = true;
    // }
    // if(!consigneeFields.state || (consigneeFields.state.trim().length === 0)) {
    //   formValid = false;
    //   error.state = true;
    // }
    // if(!consigneeFields.city || (consigneeFields.city.trim().length === 0)) {
    //   formValid = false;
    //   error.city = true;
    // }
    // if(!consigneeFields.zip || (consigneeFields.zip.trim().length === 0)) {
    //   formValid = false;
    //   error.zip = true;
    // }
    if (!consigneeFields.email) {
      error.email = true;
      formValid = false;
    }
    if (consigneeFields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(consigneeFields.email)) {
      error.email = true;
      error.email_msg = 'Enter valid email address';
      formValid = false;
    }
    
    // Validate duplicate emails in notification list
    if (consigneeFields.mails && consigneeFields.mails.length > 0) {
      const primaryEmail = consigneeFields.email?.toLowerCase();
      const emailMap = {};
      const mailErrors = {};
      
      consigneeFields.mails.forEach((mail, index) => {
        if (!mail.deleted && mail.email) {
          const emailLower = mail.email.toLowerCase();
          
          // Check if duplicate of primary email
          if (emailLower === primaryEmail) {
            mailErrors[index] = 'This email address already exists';
            formValid = false;
          }
          // Check if duplicate of another notification email
          else if (emailMap[emailLower] !== undefined) {
            mailErrors[index] = 'This email address already exists';
            formValid = false;
          } else {
            emailMap[emailLower] = index;
          }
        }
      });
      
      if (Object.keys(mailErrors).length > 0) {
        error.mails = mailErrors;
      }
    }
    
    this.setState({ consigneeFieldsErrors: error });
    return formValid;
  };

  addConsignee = (e) => {
    e.preventDefault();
    if (this.validateConsignee()) {
      this.setState({ submitting: true });
      const phoneCode = this.state.consigneeFields.phone_code || '';
      const phoneNum = this.state.consigneeFields.phone || '';
      http.post('consignee', {
        ...this.state.consigneeFields,
        phone: phoneNum ? `${phoneCode}${phoneNum}` : null
      }).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            modal: false,
            action: false,
            submitting: false,
          }, () => {
            this.fetchConsignee(data.data?.id);
          });
        } else {
          this.setState({ submitting: false });
        }
      }).catch(() => {
        this.setState({ submitting: false });
      });
    }

  };

  editConsignee = (e) => {
    e.preventDefault();
    if (this.validateConsignee()) {
      this.setState({ submitting: true });
      const phoneCode = this.state.consigneeFields.phone_code || '';
      const phoneNum = this.state.consigneeFields.phone || '';
      http.put('consignee/' + this.state.consigneeFields.id, {
        ...this.state.consigneeFields,
        phone: phoneNum ? `${phoneCode}${phoneNum}` : null
      }).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            submitting: false,
            modal: false,
            action: false 
          }, () => {
            this.fetchConsignee(this.state.consigneeFields.id);
          });
        // success
        } else {
          this.setState({ submitting: false });
        }
      }).catch(() => {
        this.setState({ submitting: false });
      });
    }
  };

  onAddCMail = () => {
    this.setState({
      consigneeFields: {
        ...this.state.consigneeFields,
        mails: [...this.state.consigneeFields.mails || [], {
          email: '',
          deleted: false,
          failed: false
        }]
      }
    });
  };

  onChangeCMail = (index, e) => {
    let value = e.target.value;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    let mails = [...this.state.consigneeFields.mails];
    mails[index][e.target.name] = value;
    
    // Validate for duplicate emails
    const error = { ...this.state.consigneeFieldsErrors };
    if (!error.mails) error.mails = {};
    
    if (e.target.name === 'email' && value) {
      const primaryEmail = this.state.consigneeFields.email?.toLowerCase();
      const allEmails = [
        primaryEmail,
        ...mails
          .filter((m, i) => !m.deleted && i !== index)
          .map(m => m.email?.toLowerCase())
      ];
      
      if (allEmails.includes(value.toLowerCase())) {
        error.mails[index] = 'This email address already exists';
      } else {
        delete error.mails[index];
      }
    } else if (e.target.name === 'email' && !value) {
      delete error.mails[index];
    }
    
    this.setState({
      consigneeFields: {
        ...this.state.consigneeFields,
        mails,
      },
      consigneeFieldsErrors: error,
    });
  };

  onDeleteCMail = (index) => {
    let mails = [...this.state.consigneeFields.mails];
    mails[index].deleted = true;
    
    // Clear error for deleted email
    const error = { ...this.state.consigneeFieldsErrors };
    if (error.mails && error.mails[index]) {
      delete error.mails[index];
    }
    
    this.setState({
      consigneeFields: {
        ...this.state.consigneeFields,
        mails,
      },
      consigneeFieldsErrors: error,
    });
  };

  onDelteConsignee = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteConsignee(id),
    });
  };

  deleteConsignee = (id) => {
    http.delete('consignee/' + id).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
        this.fetchConsignee();
      }
    });
  };  
  onRequestInfoUpdate = (e, fromModal = false) => {
    const { consigneeFields } = this.state;

    this.props.setDelete({
      modal: true,
      id: true,
      anchorEl: e.currentTarget,
      confirmMessage: (
        <span>
          This will send a registration update request email to <strong>{consigneeFields.email}</strong>. Do you want to continue?
          {!fromModal && (
            <>
              <br />
              <strong>Note: any unsaved changes will be saved</strong>
            </>
          )}
        </span>
      ),
      confirmBtn: 'Yes',
      closeBtn: 'No',
      onConfirm: () => this.requestInfoUpdate(),
    });
  };

  requestInfoUpdate = () => {
    // Close confirmation modal immediately
    this.props.setDelete({
      modal: false,
      id: false,
      anchorEl: false,
      onConfirm: () => { },
    });
    
    if (this.validateConsignee()) {
      this.setState({ requestingUpdate: true });
      // Send all consignee fields to save any unsaved changes
      const phoneCode = this.state.consigneeFields.phone_code || '';
      const phoneNum = this.state.consigneeFields.phone || '';
      const payload = {
        ...this.state.consigneeFields,
        phone: phoneNum ? `${phoneCode}${phoneNum}` : null
      };
      http.post('consignee/send-registration-email', payload).then(({ data }) => {
        if (data.status == 'success') {
          // Preserve the consignee ID (from response for new, from state for existing) to re-select after fetching
          const consigneeId = data.data?.id || this.state.consigneeFields.id;
          this.setState({
            modal: false,
            action: false,
            requestingUpdate: false,
          });
          this.fetchConsignee(consigneeId);
        } else {
          if (data.message?.toLowerCase().includes('email')) {
            this.setState({
              consigneeFieldsErrors: {
                ...this.state.consigneeFieldsErrors,
                email: true,
                email_msg: data.message
              },
              requestingUpdate: false,
            });
          } else {
            this.setState({ requestingUpdate: false });
          }
        }
      }).catch((err) => {
        const errorMsg = err?.response?.data?.message;
        if (errorMsg?.toLowerCase().includes('email')) {
          this.setState({
            consigneeFieldsErrors: {
              ...this.state.consigneeFieldsErrors,
              email: true,
              email_msg: errorMsg
            },
            requestingUpdate: false,
          });
        } else {
          this.setState({ requestingUpdate: false });
        }
      });
    }
  };
  fetchConsigneeDetails = (row = {}) => {
    this.setState({ activeAirline: row });
    let id = row?.id;
    if (row?.id === -1 || !row?.id) {
      id = 'ALL';
    }
  
    // http.get('/airlineaccessoriess')
    http.get(`/loading_accessories?airlineId=${id}`)
      .then(response => {
        const { data } = response;
        if (data.status === 'success') {
          this.setState({ accessories: data.data });
  
        }
      })
      .catch(error => {
        this.setState({ accessories: [] });
        console.error('Error fetching data:', error);
      });
  };

  filterData = () => {
    // Left as legacy/no-op fallback since pagination handles this on server side
  };

  onPageChange = (newPage) => {
    this.setState({ page: newPage }, () => this.fetchConsignee());
  };

  onRowsPerPageChange = (newLimit) => {
    this.setState({
      limit: newLimit,
      page: 1 
    }, () => this.fetchConsignee());
  };

  handleSearchClick = () => {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.fetchConsignee();
  };

  onChangeFilter = (e) => {
    const { name, value } = e.target;
    this.setState({
      filter: {
        ...this.state.filter,
        [name]: value
      },
      page: 1, // Reset page on filter/search change
    }, () => {
      if (name === 'search' && value === '') {
        this.fetchConsignee();
      } else if (name !== 'search') {
        this.fetchConsignee();
      }
    });
  };

  render() {
    return (
      <>
        <Consignee
          onChangeCMail={this.onChangeCMail}
          action={this.state.action}
          consigneeFields={this.state.consigneeFields}
          consigneeFieldsErrors={this.state.consigneeFieldsErrors}
          onChangeConsignee={this.onChangeConsignee}
          addConsignee={this.addConsignee}
          editConsignee={this.editConsignee}
          handleOpen={this.handleOpen}
          onDeleteCMail={this.onDeleteCMail}
          consignees={this.state.consignees}
          onDelteConsignee={this.onDelteConsignee}
          onAddCMail={this.onAddCMail}
          onChangeFilter={this.onChangeFilter}
          filterData={this.handleSearchClick} // Triggers server-side fetching directly and clears timeout
          filter={this.state.filter}
          filteredData={this.state.filteredData}
          requestingUpdate={this.state.requestingUpdate}
          onRequestInfoUpdate={this.onRequestInfoUpdate}
          submitting={this.state.submitting}
          page={this.state.page}
          limit={this.state.limit}
          totalItems={this.state.totalItems}
          onPageChange={this.onPageChange}
          onRowsPerPageChange={this.onRowsPerPageChange}
        />
        <ConsigneeModal
          modal={this.state.modal}
          action={this.state.action}
          consigneeFields={this.state.consigneeFields}
          consigneeFieldsErrors={this.state.consigneeFieldsErrors}
          onChangeConsignee={this.onChangeConsignee}
          addConsignee={this.addConsignee}
          editConsignee={this.editConsignee}
          onClose={this.onClose}
          onAddCMail={this.onAddCMail}
          onChangeCMail={this.onChangeCMail}
          onDeleteCMail={this.onDeleteCMail}
          onRequestInfoUpdate={this.onRequestInfoUpdate}
          requestingUpdate={this.state.requestingUpdate}
          submitting={this.state.submitting}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(ConsigneeContainer);